import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CartService, OrderRow, OrderService, OrderToBasketService, ProductService } from 'gung-standard';
import { first, switchMap, forkJoin, of, map } from 'rxjs';
import { OttoOlsenModalService } from './otto-olsen-modal.service';

@Injectable({
  providedIn: 'root'
})
export class OttoOlsenOrderToBasketService extends OrderToBasketService {
  constructor(
    protected cartService: CartService,
    protected orderService: OrderService,
    protected productService: ProductService,
    protected modalService: OttoOlsenModalService,
    protected translationService: TranslateService
  ) {
    super(cartService, orderService, productService, modalService, translationService);
  }

  public async addOrderToBasket(orderId: string, replace?: boolean): Promise<void> {
    const excluded = this.getExcludedProductIds();
    this.orderService
      .getOrder(orderId)
      .pipe(
        first(),
        switchMap(order =>
          forkJoin({
            order: of(order),
            blockedProducts: this.productService.getBlockedProducts(order.rows.filter(row => row.extra.orp.ordradst !== 90).map(row => row.productId)).pipe(first())
          })
        ),
        map(({ order, blockedProducts }) => {
          this.modalService
            .openAddOrderToCartModal().then(result => {
              const blocked: string[] = [];
              const orderRows: OrderRow[] = [];
              if (result) {
                if (result === 'replace') {
                  this.cartService.clearCart();
                }

                for (const productId of Object.keys(blockedProducts)) {
                  if (excluded.includes(productId)) {
                    continue;
                  }

                  if (!blockedProducts[productId]) {
                    const orderRow = order.rows.find(row => row.productId === productId);
                    if (!!orderRow && orderRow.extra.orp.ordradnrstrpos === 0) {
                      orderRows.push(orderRow);
                    }
                  } else {
                    blocked.push(productId);
                  }
                }
              }
              if (blocked.length > 0) {
                this.modalService
                  .openConfirmYesNoModal(
                    this.translationService.instant('EXCLUDED_PRODUCTS'),
                    this.translationService.instant('EXCLUDED_PRODUCTS_MESSAGE', { products: blocked.join(', ') }),
                    null,
                    'OK',
                    null
                  )
                  .then(proceed => {
                    if (proceed) {
                      this.addRows(orderRows);
                    }
                  });
              } else {
                this.addRows(orderRows);
               
              }
            });
        })
      )
      .toPromise();
  }
}
